import { MatchData, OddsData } from "@/interfaces/liveGamesType";
import { CircularProgress, Grid } from "@mui/material";
import React from "react";
import * as S from "../styles";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { MdOutlineAnalytics, MdQueryStats } from "react-icons/md";
import { StringToNumber } from "@/@types/customTypes";
import { leaguesBackImage, leaguesNames } from "../data";
import { InfiniteData } from "@tanstack/react-query";
import { UseUser } from "@/context/UserContext";
import { useAuth } from "@/context/AuthContext";

interface IGameData extends MatchData {
  loading?: boolean;
}

interface IGameAnalysis extends MatchData {
  iframeId?: number;
  matchOdds: StringToNumber<OddsData>;
}

interface MatchesProps {
  gamesData?: IGameData[];
  gamesPages?: InfiniteData<IGameData[], unknown>;
  gameAnalysis: IGameAnalysis[];
  grabStatistics: (gameObj: MatchData) => void;
  removeDetails?: boolean;
  useInfiniteQuery?: boolean;
}

const getCorrectLeagueName = (leagueName: string) => {
  try {
    const getPartialName = leagueName.slice(0, 6);
    const nameIndex = leaguesNames.findIndex((el) =>
      el.includes(getPartialName)
    );

    if (nameIndex !== -1) {
      return leaguesNames[nameIndex];
    }

    return "";
  } catch (e) {
    return "";
  }
};

export default function Matches({
  gamesData,
  gamesPages,
  gameAnalysis,
  grabStatistics,
  removeDetails,
  useInfiniteQuery,
}: MatchesProps) {
  const { setPaymentModal } = UseUser();
  const { decodedToken } = useAuth();

  const matches = (el: IGameData) => {
    return (
      <Grid
        item
        xl={4}
        md={4}
        width="100%"
        key={`${el.match_awayteam_id} ${el.match_hometeam_id} ${el.match_id}`}
      >
        <S.GameCardContainer>
          <S.GameBackImage>
            <img
              src={
                leaguesBackImage[
                  getCorrectLeagueName(
                    el.league_name
                  ) as keyof typeof leaguesBackImage
                ]
              }
            />
          </S.GameBackImage>
          {el.match_status === "Finished" ? (
            <S.GameEndContainer>
              <span>Jogo Finalizado</span>
            </S.GameEndContainer>
          ) : null}
          <S.GameInfoLive>
            <S.TeamContainer>
              <img src={el.team_home_badge} />
              <p>{el.match_hometeam_name}</p>
              <small>Em Casa</small>
            </S.TeamContainer>
            <S.GameScore>
              <h3>
                &nbsp; &nbsp; {el.match_hometeam_score} :{" "}
                {el.match_awayteam_score} &nbsp; &nbsp;
              </h3>
              <small>{el.match_time}</small>
            </S.GameScore>
            <S.TeamContainer>
              <img src={el.team_away_badge} />
              <p>{el.match_awayteam_name}</p>
              <small>Fora</small>
            </S.TeamContainer>
          </S.GameInfoLive>
          <S.StatisticsButton
            variant="outlined"
            onClick={() =>
              decodedToken.isActive ? grabStatistics(el) : setPaymentModal(true)
            }
            disabled={
              el.loading ||
              !!gameAnalysis.find((element) => element.match_id === el.match_id)
            }
          >
            {el.loading ? (
              <CircularProgress />
            ) : gameAnalysis.find(
                (element) => element.match_id === el.match_id
              ) ? (
              <S.StatisticsContainer>
                <AiOutlineCheckCircle />
                Acompanhando as Estatísticas
              </S.StatisticsContainer>
            ) : (
              <S.StatisticsContainer>
                <MdOutlineAnalytics />
                Acompanhar Estatísticas
              </S.StatisticsContainer>
            )}
          </S.StatisticsButton>
          {removeDetails ? (
            ""
          ) : (
            <S.StatisticsButton
              variant="outlined"
              onClick={() =>
                decodedToken.isActive
                  ? window.open(
                      `dashboard/detalhado/${el.match_id}`,
                      "rel=noopener noreferrer"
                    )
                  : setPaymentModal(true)
              }
            >
              <MdQueryStats />
              Estatísticas mais detalhadas
            </S.StatisticsButton>
          )}
        </S.GameCardContainer>
      </Grid>
    );
  };

  const notFound = () => (
    <S.NotFoundContainer>
      <span>:(</span>
      <h3>Nenhuma Partida Encontrada</h3>
    </S.NotFoundContainer>
  );
  return (
    <Grid container spacing={2} justifyContent="center">
      {/* TODO: Refatorar essa monstruosidade */}
      {useInfiniteQuery
        ? gamesPages?.pages.flat(1).length
          ? gamesPages?.pages.map((el) => {
              return el.map((match) => matches(match));
            })
          : notFound()
        : gamesData?.length
        ? gamesData?.map((games) => matches(games))
        : notFound()}
    </Grid>
  );
}
